export interface Routine {
  ID: number;
  DO_ID: number;
  CONTENTS: string;
  DO_DATE: Date;
  CREATE_DATE: Date;
  DONE: boolean;
}

export const getRoutine = async (date: string) => {
  let result: Routine[] = [];
  await fetch("/db.php?cmd=RR", {
    method: "post",
    body: JSON.stringify({ DO_DATE: date }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      res.forEach((r: any) => {
        let rItem: Routine = {
          ID: +r.ID,
          DO_ID: +r.DO_ID,
          CONTENTS: r.CONTENTS,
          DO_DATE: r.DO_DATE,
          CREATE_DATE: r.CREATE_DATE,
          DONE: +r.DONE ? true : false,
        };
        result.push(rItem);
      });
    });
  return result;
};

export const saveDoRoutine = async (params: any) => {
  let result = "";
  await fetch("/db.php?cmd=C", {
    method: "post",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const removeDoRoutine = async (params: any) => {
  let result = "";
  await fetch("/db.php?cmd=D", {
    method: "post",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const getRoutineSchedule = async () => {
  let result = "";
  await fetch("/db.php?cmd=getRoutineSchedule")
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};
